<template>
    <div>
      <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>
      <basic-table
        v-if="accountingPeriod"
        :items="accountingPeriod"
        :fields="accountingPeriodFields"
        @ClickOnEditButton="editItem"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"
        isEdit="true"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
      <editModal :editItem="selectedAccountingPeriod"/>
    </div>
</template>

<script>
import editModal from './editModal'
import moment from 'moment'
export default {
  components: {
    editModal
  },
  data () {
    return {
      accountingPeriodFields: [
        {key: 'static_id', label: 'ID', sortable: true},
        {key: 'id', label: this.$i18n.t('Serial ID'), sortable: true},
        {key: 'begin2', label: this.$i18n.t('Start date'), sortable: true},
        {key: 'end2', label: this.$i18n.t('End date'), sortable: true},
        {key: 'namePeriodicType', label: this.$i18n.t('Period type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedAccountingPeriod: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedAccountingPeriod = {
        id: 0,
        start_time: moment().format('YYYY-MM-DDThh:mm'),
        periodic_type: 1,
        custom_duration: 300,
        charge_interval: 1,
        invoice_month: 0,
        end: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditAccountingPeriod', '#btnShow')
    },
    editItem (item) {
      this.selectedAccountingPeriod = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditAccountingPeriod', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    accountingPeriod () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))
      copy = copy.filter(function (value) {
        return value.static_id !== 0
      })
      for (let el of copy) {
        el.begin2 = moment(Number(el.begin) * 1000).format('YYYY-MM-DD hh:mm')
        el.end2 = moment(Number(el.end) * 1000).format('YYYY-MM-DD hh:mm')
        el.namePeriodicType = ''
        switch (el.periodic_type) {
          case 1:
            el.namePeriodicType = this.$i18n.t('Daily')
            break
          case 2:
            el.namePeriodicType = this.$i18n.t('Weekly')
            break
          case 3:
            el.namePeriodicType = this.$i18n.t('Monthly')
            break
          case 4:
            el.namePeriodicType = this.$i18n.t('Quarterly')
            break
          case 5:
            el.namePeriodicType = this.$i18n.t('Annual')
            break
          case 1048576:
            el.namePeriodicType = this.$i18n.t('Custom duration')
            break
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_ACCOUNTING_PERIODS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/additional/accountingPeriods/main.vue